import React, { memo } from 'react'

import { arrayOf, func, shape, string } from 'prop-types'

function CategoryGrid({ categories, onSelectCategory }) {
  return (
    <div className="image-assistant-panel__section">
      <span className="image-assistant-panel__overline cgt-overline-sm">
        The most searched image categories
      </span>
      <div className="image-assistant-panel__grid">
        {categories.map(category => (
          <button
            key={category.value}
            type="button"
            className="image-assistant-panel__card image-assistant-panel__card--category"
            onClick={() => onSelectCategory(category)}
          >
            <img
              className="image-assistant-panel__card-image"
              src={category.cover}
              alt=""
              loading="lazy"
              decoding="async"
            />
            <span className="image-assistant-panel__card-label cgt-caption-semibold">
              {category.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

CategoryGrid.propTypes = {
  categories: arrayOf(shape({
    value: string.isRequired,
    name: string.isRequired,
    cover: string.isRequired,
  })).isRequired,
  onSelectCategory: func.isRequired,
}

export default memo(CategoryGrid)
